document.addEventListener('click', event => {
  const arrow = event.target.closest('[data-born-cart-scroll]');
  if (!arrow) return;
  const rail = arrow.closest('.born-cart-recommendations').querySelector('.born-cart-recommendations__rail');
  const card = rail.querySelector('.born-cart-card');
  rail.scrollBy({left: Number(arrow.dataset.bornCartScroll) * ((card?.getBoundingClientRect().width || 150) + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});

/* Combo lines (Home / Away / Third jerseys, each with its own size): hide the single "Size" line
   that comes from the variant and show the size + name/number of every jersey instead. */
(() => {
  const KITS = ['Home', 'Away', 'Third'];
  let busy = false, again = false;
  const esc = s => String(s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
  async function fix() {
    const lines = document.querySelectorAll('.arena-sdr__line[data-key]:not([data-combo-ok]), .arena-bagline[data-key]:not([data-combo-ok])');
    if (!lines.length) return;
    if (busy) { again = true; return; }
    busy = true;
    try {
      const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(r => r.json());
      const byKey = {};
      (cart.items || []).forEach(it => { byKey[it.key] = it; });
      lines.forEach(line => {
        line.setAttribute('data-combo-ok', '');
        const it = byKey[line.dataset.key];
        const props = it && it.properties || {};
        const kits = Object.keys(props).filter(k => k[0] !== '_' && props[k] && (KITS.includes(k) || String(props[k]).toLowerCase().indexOf('size ') === 0));
        if (!kits.length) return;
        const drawer = line.classList.contains('arena-sdr__line');
        const specs = line.querySelectorAll(drawer ? '.arena-sdr__spec' : '.arena-bagline__spec');
        specs.forEach(s => { const st = s.textContent.trim().toLowerCase(); if (st.indexOf('size') === 0 || st.indexOf('talla') === 0) s.remove(); });
        if (drawer) {
          const anchor = line.querySelector('.arena-sdr__name');
          if (!anchor) return;
          let html = '';
          kits.forEach(k => { html += `<span class="arena-sdr__spec">${esc(k)} <b>${esc(String(props[k]).replace(/^size /i, ''))}</b></span>`; });
          anchor.insertAdjacentHTML('afterend', html);
        }
      });
    } catch (e) { console.error('[born] combo lines', e); }
    busy = false;
    if (again) { again = false; fix(); }
  }
  let t;
  const run = () => { clearTimeout(t); t = setTimeout(fix, 60); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(run).observe(document.documentElement, {childList: true, subtree: true});
})();